var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-lease-summary',{attrs:{"show_card":false,"lease":_vm.lease,"title":'Details'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }